import React from 'react';
import { withLazyComponent } from './with-lazy-component';
import { TextAreaSkeleton } from "../components/loading/text-area-skeleton";

const Component = React.lazy(() => import('../components/text-area'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component, TextAreaSkeleton);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    config: {
      behaviour: 'text-input',
    },
  };
}
